import React from "react";

const SurveyEmbed = () => {
  return (
    <div style={{ position: "relative", height: "80dvh", overflow: "auto" }}>
      <iframe
        src="https://sincra.xyz/s/cmc9kultg000gmq01ure359l4"
        frameBorder="0"
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          border: 0,
        }}
        title="Formbricks Survey"
        allow="clipboard-write"
      ></iframe>
    </div>
  );
};

export default SurveyEmbed;
